import { Box, Container, Typography } from '@mui/material';
import styles from './FingpayCmsLandingPage.module.css';
import { checkFingpayCmsStatusApi, fingpayCmsAuthLinkApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import BcConvertModal from 'views/Components/BcConvertModal';
import { checkIsMerchantOrBcGlobal } from 'redux/merchantSlice';
const FingpayCmsLandingPage = () => {
    const [loading, setLoading] = useState(true);
    const [opened, setOpened] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { agentType, pendingStatus } = useSelector((state) => state.merchant);
    const merchantModalOpen =
        agentType === 'Merchant' ||
        localStorage.getItem('shouldshowEsign') === 'true' ||
        pendingStatus ||
        localStorage.getItem('merchantToBcStatus') === 'rejected';
    const isBcConvertPending = pendingStatus;
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const generateAuthLink = async () => {
        try {
            const agentid = localStorage.getItem('id');
            const payload = { agentid, amount: 1 };
            const response = await fingpayCmsAuthLinkApi(payload);

            if (response?.status === 200) {
                const base64Link = response?.data?.link;
                const decodedLink = atob(base64Link);
                const innerTab = window.open(decodedLink, 'about:blank', 'Inner Tab', 'width=800,height=1000');
                if (!innerTab) {
                    alert('Please allow popups for this site to open the CMS window.');
                } else {
                    setOpened(true);
                }
            }
        } catch (error) {
            console.error('Auth link generation failed', error);
        } finally {
            setLoading(false);
        }
    };
    const checkRegistrationStatus = async () => {
        const agentid = localStorage.getItem('id');
        const payload = { agentid };
        const response = await checkFingpayCmsStatusApi(payload);
        if (response?.status === 200) {
            if (response?.data?.status && !merchantModalOpen) {
                generateAuthLink();
            }
        } else if (response?.status === 201) {
            const chequeImage = response?.data?.image_check;
            const panImage = response?.data?.img_pan;
            const aadhaarImage = response?.data?.img_aadhar;
            navigate('/cmsF/cmsOnboarding', { state: { chequeImage, panImage, aadhaarImage } });
        }
    };
    useEffect(() => {
        const allowedService = localStorage.getItem('allowedService');
        const currentService = 'CMS';
        if (!allowedService.includes(currentService)) {
            return;
        }
        checkRegistrationStatus();
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        dispatch(checkIsMerchantOrBcGlobal());
    }, [dispatch]);
    const handleGoHome = () => {
        navigate('/merchant-home');
    };

    return (
        <>
            <Box className={styles.container}>
                <Container maxWidth="sm" className={styles.contentContainer}>
                    {loading && (
                        <motion.div
                            className={styles.loaderContainer}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className={styles.spinner}></div>
                            <Typography variant="h6" className={styles.loadingText}>
                                Redirecting securely, please wait...
                            </Typography>
                        </motion.div>
                    )}

                    {!loading && opened && (
                        <motion.div
                            className={styles.messageContainer}
                            initial={{ opacity: 0, y: 40 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, ease: 'easeOut' }}
                        >
                            <motion.div
                                initial={{ scale: 0.9 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.4, ease: 'easeOut' }}
                                className={styles.iconCircle}
                            >
                                ✅
                            </motion.div>

                            <Typography variant="h5" className={styles.successTitle}>
                                You're All Set!
                            </Typography>

                            <Typography variant="body1" className={styles.successSubtitle}>
                                The CMS has been opened in a new window. Please proceed there to continue the service.
                            </Typography>

                            <motion.button
                                className={styles.backButton}
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                onClick={handleGoHome}
                            >
                                ⬅ Go to Home Page
                            </motion.button>
                        </motion.div>
                    )}
                </Container>
            </Box>
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    // handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    shouldshowEsign={shouldshowEsign}
                />
            )}
        </>
    );
};

export default FingpayCmsLandingPage;
